import React from "react";
import { Card, Typography } from "antd";

const { Title, Paragraph } = Typography;

const AuthErrorPage: React.FC = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Card style={{ maxWidth: 500, textAlign: "center", padding: 20 }}>
        <Title>Access Denied !</Title>
        <Paragraph>
          You do not have access to this Application. Please submit a
          <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=Semqse-lFUi3r_fEqlRrKLX6cxkwiT5MomVnTWCmsohUM0JGRTFLNUczSlpEN0gxUzk2N1JFS0UwQS4u" style={{ fontWeight: "bold" }} target="_blank"> Support&nbsp;Request</a> to access the application.
        </Paragraph>
        <Paragraph>
            <a href="/login">Go back to Login</a>
        </Paragraph>
      </Card>
    </div>
  );
};

export default AuthErrorPage;